<template>
  <WindowModal title="How to Claim">
    <ol class="help-list">
      <li>Open Chrome with the installed MetaMask extension.</li>
      <li>Make sure you’ve selected the wallet you’ve invested with.</li>
      <li>Check that the network is set to ‘Ethereum Mainnet’.</li>
      <li>Visit invest.bolide.fi.</li>
      <li>Click "Connect".</li>
      <li>Connect via MetaMask.</li>
      <li>Press "Claim".</li>
      <li>BLID will be claimed to your wallet</li>
    </ol>
    <div class="help-footer">
      <button class="help-btn" @click="$emit('close')">
        Close
      </button>
    </div>
  </WindowModal>
</template>

<script>
import WindowModal from "@/components/WindowModal";

export default {
  name:"HelpModal",
  components: { WindowModal },
  emits: ['close'],
}
</script>

<style scoped>
.help-list {
  text-align: left;
  line-height: 1.4;
  margin: 16px 0 24px;
}
.help-list li {
  margin: 8px 0;
}
.help-btn {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  background-color: rgba(32, 192, 106, 1);
  font-weight: bold;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  color: #FFFFFF;
  transition: all 0.25s ease;
}
.help-btn:hover {
  background-color: rgba(32, 192, 106, 0.5);
}
</style>